import { Button } from "@/components/ui/button";
import { useLeadFunnel } from "@/contexts/LeadFunnelContext";

export const CtaClose = () => {
  const { open } = useLeadFunnel();
  return (
    <section className="bg-charcoal text-warm-white">
      <div className="container-tight py-16 md:py-20 flex flex-col md:flex-row items-center justify-between gap-8 text-center md:text-left">
        <h2 className="font-display text-3xl md:text-5xl uppercase">
          Ready to clear your space?
        </h2>
        <Button variant="brass" size="xl" onClick={open}>
          Request Service
        </Button>
      </div>
    </section>
  );
};
